import { render, staticRenderFns } from "./addAkpr.vue?vue&type=template&id=d417abac"
import script from "./addAkpr.vue?vue&type=script&lang=js"
export * from "./addAkpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports